<template>
  <div>
    <main role="main">
      <div  class="container"> 
        <section id="contact" class="fond">
          <h1 data-aos="fade-right" data-aos-delay="200">{{ $t("home.nav.contact") }}</h1>
          <div class="content" data-aos="fade-left" data-aos-delay="400">
            <!-- <div id="mailmunch-contact" :class='$t("home.contact.general.form")'></div> -->
            <div id="hubspotForm"></div>
          </div>
        </section>     
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'ContactPage',
  mounted: () => {
    // if(document.head.querySelector("#mailmunch-script") != null)
    //   document.head.querySelector("#mailmunch-script").remove()
    // let mailMunchScript = document.createElement('script')
    // mailMunchScript.setAttribute('src', '//a.mailmunch.co/app/v1/site.js')
    // mailMunchScript.setAttribute('id', 'mailmunch-script')
    // mailMunchScript.setAttribute('data-mailmunch-site-id', '709732')
    // mailMunchScript.setAttribute('async', 'async')
    // document.head.appendChild(mailMunchScript)

    const script = document.createElement("script");
    script.src="//js.hsforms.net/forms/embed/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      console.log('load script', window.hbspt)
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "6598180",
          formId: "fd485094-8ba2-4f00-bd3c-126f28448538",
          target: "#hubspotForm"
        })
      }
    })
  }
}
</script>
